import css from 'styled-jsx/css';
import { isRTL, rgba } from 'common/styling/theme';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .PaymentMetadata {
    &__list {
      padding: 20px 28px;

      &-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 56px;
        border-bottom: 1px solid #e8e8e8;
      }

      &-info {
        display: flex;
        align-items: center;
        gap: 16px;
      }

      &-time {
        font-size: 18px;
        font-weight: 500;
        white-space: nowrap;
      }

      &-seconds {
        color: rgba(0, 0, 0, 0.25);
        padding-right: 5px;
      }

      &-date {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.5);
        white-space: nowrap;
      }

      &-button {
        border: none;
        background: transparent;
        color: rgba(0, 0, 0, 0.25);
        cursor: pointer;
        font-size: 14px;
        padding: 0;
        text-decoration: underline;

        &:hover {
          color: rgba(0, 0, 0, 0.5);
        }
      }
    }

    .NoItemsPanel {
      height: 300px !important;
    }

    .Collapsible {
      background: #ffffff;
      margin-bottom: 20px;
    }

    .Collapsible__caption {
      line-height: 32px;
      font-size: 26px;
      font-weight: 300;

      @include respond-to(sm) {
        font-size: 20px;
        line-height: 24px;
      }
    }

    .Collapsible__header {
      padding: rem(15px 28px);
      position: relative;
    }

    .Collapsible__arrow {
      position: absolute;
      right: ${isRTL ? 'auto' : '30px'};
      left: ${isRTL ? '30px' : 'auto'};
      top: 50%;
    }

    .Collapsible__arrow-right {
      transform: ${isRTL
        ? 'translateY(-50%) rotate(135deg) !important'
        : ' translateY(-50%) rotate(-45deg) !important'};
    }

    .Collapsible__arrow-down {
      top: 40%;
      transform: rotate(45deg) translateY(-50%) !important;
    }

    @include respond-to(sm) {
      .PaymentMetadata__list-item {
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        padding: 14px 0;
      }

      .PaymentMetadata__list-info {
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
      }

      .PaymentMetadata__list-time {
        font-size: 18px;
      }

      .PaymentMetadata__list-date {
        font-size: 14px;
      }
    }
  }

  .PaymentMetadataModal {
    &__info {
      max-height: 60vh;
      overflow-y: auto;
      padding-right: 20px;
    }

    &__row {
      display: flex;
      align-items: flex-start;
      padding: 10px 0;
    }

    &__row--nested {
      flex-direction: column;
    }

    // Полоса только у первого уровня
    &__row--root {
      border-bottom: 1px solid #ececec;
    }

    &__key {
      width: 220px;
      color: rgba(0, 0, 0, 0.5);
      font-size: 14px;
      word-break: break-word;
    }

    &__value {
      flex: 1;
      font-size: 16px;
      min-width: 0;
      word-break: break-word;
    }

    .PaymentMetadataModal__object,
    .PaymentMetadataModal__array {
      position: relative;
      margin-left: 18px;
      padding-left: 22px;
    }

    .PaymentMetadataModal__level-0 {
      margin: 0;
      padding: 0;
    }

    .PaymentMetadataModal__level-0::before {
      display: none;
    }

    .PaymentMetadataModal__object::before,
    .PaymentMetadataModal__array::before {
      content: '';
      position: absolute;
      left: 8px;
      top: 0;
      bottom: 0;
      width: 1px;
      background: #ececec;
    }

    &__actions {
      width: 100%;
      padding-top: 20px;
      display: flex;
      justify-content: space-between;
      gap: 10px;

      &-copy {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
        height: 46px;
        min-width: 150px;
        padding: 0 16px;
        border-radius: 3px;
        font-size: 15px;

        span {
          word-break: keep-all;
        }

        svg {
          width: 16px;
          path {
            fill: white;
          }
        }
      }
    }

    @include respond-to(md) {
      &__info {
        max-height: 60vh;
        overflow-y: auto;
      }

      &__row {
        flex-direction: column;
        gap: 4px;
        padding: 12px 0;
      }

      &__key {
        width: 100%;
        font-size: 13px;
      }

      &__value {
        width: 100%;
        font-size: 14px;
      }

      &__object,
      &__array {
        padding-left: 15px !important;
        margin-left: 5px !important;
      }
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .PaymentMetadataModal {
      &__actions-copy {
        background: ${colors.primary.hex};
        color: ${colors.white.hex};
        &:hover {
          box-shadow: 0 3px 6px 0 ${rgba([colors.primary.rgb, 0.4])};
        }
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
